<script setup lang="ts">
import img from '@/assets/imgs/swap/deposit.png'
import imgErr from '@/assets/imgs/swap/err.png'
import imgExchange from '@/assets/imgs/swap/Exchange.png'
import imgLoad from '@/assets/imgs/swap/load.png'

interface Prors {
  src?: string
  state?: 'none' | 'exchange' | 'load' | 'err'
  rotate?: boolean
}
withDefaults(defineProps<Prors>(), {
  src: img,
  state: 'none',
  rotate: false,
})
</script>

<template>
  <div class="flex flex-col items-center relative">
    <img class="w-80px h-80px" :src="src">
    <div class="w-70px h-7px bg-[#1A2342] rounded-70% mt-2" />
    <i v-if="state === 'none'" class="state" />
    <img v-if="state === 'exchange'" class="state" :src="imgExchange">
    <img v-if="state === 'err'" class="state" :src="imgErr">
    <img v-if="state === 'load'" class="state" :class="{ rotating: rotate }" :src="imgLoad">
  </div>
</template>

<style lang="scss" scoped>
.state{position: absolute;
 z-index: 1;
 top: 50px;
 right: 20px;
 width: 20px;
}

.rotating {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
